import { AssetConfig } from '@lib/services/_api';
import client from '@lib/services/client';

export const paging = client.api.assetConfigControllerList;

export const getAll = () => {
  return client.api.assetConfigControllerGetAll();
};

export const upsert = (data: AssetConfig) => {
  return client.api.assetConfigControllerUpsert(data);
};

export const deleteById = (id: any) => {
  return client.api.assetConfigControllerDeleteById(id);
};
